import { __decorate, __extends } from "tslib";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { PostLogo } from '../../App/Builder/PostLogo';
import Core from '../../Core';
import Messages from '../../Core/Messages';
import UserManager from '../../Core/UserManager';
import StoreLoadingBar from '../../Stores/Tools/StoreLoadingBar';
import { LoadingSpinner } from '../Shared/LoadingSpinner';
import './../../Css/PinPad.css';
var PinPad = /** @class */ (function (_super) {
    __extends(PinPad, _super);
    /**
     * Class constructor
     * @param {IPinPadProps} props Component Props
     * @returns {void}
     * */
    function PinPad(props) {
        var _this = _super.call(this, props) || this;
        _this.Initilize();
        return _this;
    }
    /**Class initializer */
    PinPad.prototype.Initilize = function () {
        window["StatusBar"].backgroundColorByHexString("#ffcc00");
        this.state = {
            Loading: true,
            Set: false,
            Pin: '',
            PinConfirm: '',
            FingerPrint: false,
            Validating: false
        };
    };
    /**Fingerprint reader is available */
    PinPad.prototype.FingerPrintAvailable = function () {
        var that = this;
        that.setState({
            FingerPrint: true
        }, function () {
            if (!that.state.Set) {
                that.ShowFingerPrintReader();
            }
        });
    };
    /**Display fingerprint reader to user */
    PinPad.prototype.ShowFingerPrintReader = function () {
        window["Fingerprint"].show({
            clientId: UserManager.ClientId,
            clientSecret: UserManager.AuthorityEndPoint + 'fpr' + UserManager.ClientId //Only necessary for Android
        }, this.FingerprintReadSuccess.bind(this), function () { });
    };
    /**Fingerprint read successfully */
    PinPad.prototype.FingerprintReadSuccess = function () {
        var that = this;
        that.setState({
            Validating: true
        }, function () {
            UserManager.AppUnlock()
                .then(function (res) {
                if (res) {
                    Core.InitApiDependencies()
                        .then(function () {
                        that.props.StoreUser.AppLocked = false;
                    })
                        .catch(function (err) {
                        console.error(err);
                        UserManager.SignOutRedirect();
                    });
                }
                else {
                    navigator.vibrate(1000);
                    that.setState({
                        Validating: false
                    });
                }
            });
        });
    };
    /**
     * Add number to pin
     * @param {number} value Value to add
     */
    PinPad.prototype.AddNumber = function (digit) {
        var that = this;
        var pin = that.state.Pin + digit.toString();
        if (that.state.Set && pin.length === 4) {
            if (that.state.PinConfirm === '') {
                that.setState({
                    Pin: '',
                    PinConfirm: pin
                });
            }
            else {
                if (pin !== that.state.PinConfirm) {
                    navigator.vibrate(1000);
                    that.setState({
                        Pin: '',
                        PinConfirm: ''
                    }, function () {
                        navigator.notification.alert(Messages.GetMessage('pinpad.no-match'), Messages.GetMessage('generics.common.error-title'));
                    });
                }
                else {
                    that.setState({
                        Pin: pin
                    }, function () {
                        that.Save();
                    });
                }
            }
        }
        else {
            that.setState({
                Pin: pin
            }, function () {
                if (that.state.Pin.length === 4) {
                    that.Validate();
                }
            });
        }
    };
    /**Save new Pin to storage */
    PinPad.prototype.Save = function () {
        var that = this;
        UserManager.SavePin(that.state.Pin)
            .then(function (res) {
            if (res) {
                that.Validate();
            }
            else {
                navigator.vibrate(1000);
                that.setState({
                    Pin: '',
                    PinConfirm: ''
                }, function () {
                    navigator.notification.alert(Messages.GetMessage('generics.common.error'), Messages.GetMessage('generics.common.error-title'));
                });
            }
        });
    };
    /**
     * Remove last digit from pin
     * */
    PinPad.prototype.RemoveLast = function () {
        if (this.state.Pin.length <= 3) {
            this.setState({
                Pin: this.state.Pin.substr(0, this.state.Pin.length - 1)
            });
        }
        else if (this.state.Set) {
            this.setState({
                PinConfirm: this.state.PinConfirm.substr(0, this.state.PinConfirm.length - 1)
            });
        }
    };
    /**
     * Submit and validate pin
     * @param {string} pin Pin to validate
     */
    PinPad.prototype.Validate = function () {
        var _this = this;
        var that = this;
        that.setState({
            Validating: true
        }, function () {
            UserManager.ValidatePin(_this.state.Pin)
                .then(function (res) {
                if (res) {
                    Core.InitApiDependencies()
                        .then(function () {
                        that.props.StoreUser.AppLocked = false;
                    })
                        .catch(function (err) {
                        console.error(err);
                        UserManager.SignOutRedirect();
                    });
                }
                else {
                    navigator.vibrate(1000);
                    that.setState({
                        Pin: '',
                        PinConfirm: '',
                        Validating: false
                    });
                }
            });
        });
    };
    /**User forgot pin */
    PinPad.prototype.Forgot = function () {
        navigator.notification.confirm(Messages.GetMessage('pinpad.reset.text'), this.ForgotCallback, Messages.GetMessage('pinpad.reset.title'), [Messages.GetMessage('generics.common.continue'), Messages.GetMessage('generics.common.cancel')]);
    };
    /**Reset pin (completely remove) and sign out */
    PinPad.prototype.ForgotCallback = function (buttonIndex) {
        if (buttonIndex === 1) {
            UserManager.SignOutRedirect();
        }
    };
    /**Handle component did mount event */
    PinPad.prototype.componentDidMount = function () {
        var that = this;
        if (window.outerWidth < 600) {
            window.screen.orientation.lock("portrait");
        }
        navigator.splashscreen.hide();
        UserManager.HasPin()
            .then(function (res) {
            that.setState({
                Loading: false,
                Set: !res
            }, function () {
                window["Fingerprint"].isAvailable(that.FingerPrintAvailable.bind(that), function () { });
                StoreLoadingBar.Hide();
            });
        });
    };
    /**Handle component unmount event */
    PinPad.prototype.componentWillUnmount = function () {
        window.screen.orientation.unlock();
        window["StatusBar"].backgroundColorByHexString("#3f2f1a");
    };
    /**
     * JSX.Element
     * @returns {JSX.Element} Component layout
     * */
    PinPad.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "pinpad-body w-100 h-100" },
                React.createElement("div", { id: "loading-content", className: this.state.Validating ? '' : 'd-none' },
                    React.createElement("div", { className: "loading-content-row" },
                        React.createElement("div", { className: "loading-content-column" },
                            React.createElement(LoadingSpinner, null)))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(PostLogo, null))),
                React.createElement(CSSTransition, { classNames: "fade", timeout: 300, in: !this.state.Loading, unmountOnExit: true, mountOnEnter: true },
                    React.createElement("div", { className: "row h-100" }, this.state.Loading ?
                        React.createElement(React.Fragment, null) :
                        React.createElement("div", { className: "col-12 PINcontainer" },
                            React.createElement("div", { className: "set-pin-text" },
                                React.createElement("h5", null, Messages.GetMessage('pinpad.required.title')),
                                this.state.Set ?
                                    React.createElement(React.Fragment, null, Messages.GetMessage('pinpad.required.text'))
                                    :
                                        React.createElement(React.Fragment, null),
                                React.createElement("h5", { className: "mt-3 text-left" }, this.state.PinConfirm === '' ? 'PIN Code' : 'Confirm PIN')),
                            React.createElement("div", { className: "pinpad" },
                                React.createElement("div", { className: "pin-dots" },
                                    React.createElement("span", { className: "circle mr-1 ".concat(this.state.Pin.length >= 1 ? 'toggled' : '') }),
                                    React.createElement("span", { className: "circle mr-1 ".concat(this.state.Pin.length >= 2 ? 'toggled' : '') }),
                                    React.createElement("span", { className: "circle mr-1 ".concat(this.state.Pin.length >= 3 ? 'toggled' : '') }),
                                    React.createElement("span", { className: "circle mr-1 ".concat(this.state.Pin.length === 4 ? 'toggled' : '') })),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "1", onClick: function () { return _this.AddNumber(1); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "2", onClick: function () { return _this.AddNumber(2); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "3", onClick: function () { return _this.AddNumber(3); } }),
                                React.createElement("br", null),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "4", onClick: function () { return _this.AddNumber(4); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "5", onClick: function () { return _this.AddNumber(5); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "6", onClick: function () { return _this.AddNumber(6); } }),
                                React.createElement("br", null),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "7", onClick: function () { return _this.AddNumber(7); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "8", onClick: function () { return _this.AddNumber(8); } }),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "9", onClick: function () { return _this.AddNumber(9); } }),
                                React.createElement("br", null),
                                React.createElement("span", { className: "PINspans left", onClick: function () { return _this.Forgot(); } }, Messages.GetMessage('pinpad.forgot')),
                                React.createElement("input", { type: 'button', className: 'PINbutton', value: "0", onClick: function () { return _this.AddNumber(0); } }),
                                this.state.Pin.length > 0 ?
                                    React.createElement("span", { className: "PINspans right", onClick: function () { return _this.RemoveLast(); } },
                                        React.createElement(FontAwesomeIcon, { icon: ['far', 'backspace'], size: "2x" }))
                                    :
                                        React.createElement("span", { className: 'PINspans right' }, this.state.Set || !this.state.FingerPrint ?
                                            React.createElement(React.Fragment, null, "\u00A0")
                                            :
                                                React.createElement("span", { onClick: function () { return _this.ShowFingerPrintReader(); } },
                                                    React.createElement(FontAwesomeIcon, { icon: ['far', 'fingerprint'], size: "2x" }))))))))));
    };
    PinPad = __decorate([
        inject("StoreUser"),
        observer
    ], PinPad);
    return PinPad;
}(React.Component));
export default PinPad;
//# sourceMappingURL=PinPad.js.map